import { Component, effect, OnDestroy, OnInit } from '@angular/core';
import { catchError, filter, Observable, Subject, Subscription, switchMap, tap } from 'rxjs';
import { matImports, ngImports } from '@app/shared/imports';
import { StatsService } from './stats.service';
import { Dictionary } from '@app/core/models';
import { FieldInfo, StatsAction, StatsActionType } from './models';
import { StatsSeriesComponent } from './stats-series/stats-series.component';
import { StatsTransferService } from './stats-transfer.service';
import { StatsFieldsFormComponent } from './stats-fields-form/stats-fields-form.component';

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss'],
  standalone: true,
  imports: [...ngImports, ...matImports, StatsSeriesComponent, StatsFieldsFormComponent],
  providers: [ StatsTransferService ]
})
export class StatsComponent implements OnInit, OnDestroy {

  private subscriptions = new Subscription();

  private actionSubject = new Subject<StatsAction>();

  values$ = this.actionSubject.pipe(
    filter(action => action.type === StatsActionType.GET_FIELD_VALUES),
    switchMap(() => this.stats.getFieldsValues()),
    tap((info) => this.transfer.info.set(info)),
    catchError((error: unknown, observable: Observable<Dictionary<string, FieldInfo>>) => {
      return observable;
    })
  );

  constructor(
    private stats: StatsService,
    public transfer: StatsTransferService
  ) {
    effect(() => {
      const cls = 'stats-no-scroll';
      const element = document.documentElement;

      if (this.transfer.formData()) {
        element.classList.add(cls);
      } else if (element.classList.contains(cls)) {
        element.classList.remove(cls);
      }
    });
  }

  ngOnInit(): void {
    this.subscriptions.add(this.values$.subscribe());
    this.actionSubject.next({ type: StatsActionType.GET_FIELD_VALUES });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
